import { CrudConfig } from '@src/model/table';
import { useStores } from '../../store';
import { Domain } from '@src/dtos/version.dto';
import { ActionType } from '@src/utils/enums';
import { MAX_BRONZE_DOMAINS } from '@src/utils/constants';
import Alert from '@src/components/shared/alert/alert';
import React from 'react';

const PartialDisableMessage = (domain: any) => {
    const { fwVersionBronzeStore } = useStores();

    if (domain.data.domainAction === ActionType.BLOCK) {
        if (fwVersionBronzeStore.hasReachedDomainLimitFor(ActionType.ALLOW)) {
            return <Alert header={`You've reached the max limit of ${MAX_BRONZE_DOMAINS / 2} allowed domains`} />;
        }
    } else if (fwVersionBronzeStore.hasReachedDomainLimitFor(ActionType.BLOCK)) {
        return <Alert header={`You've reached the max limit of ${MAX_BRONZE_DOMAINS / 2} blocked domains`} />;
    }

    return <></>;
};

export const useDomainsCrudConfig = (): CrudConfig<Domain> => {
    const { fwVersionBronzeStore } = useStores();

    return {
        createNewText: 'Add domain',
        displayInlineActions: !fwVersionBronzeStore.isDnsProtectionDeactivated && fwVersionBronzeStore.isSelectedBronzeVersionEditable,
        disableEditReason: fwVersionBronzeStore.bronzeDisableReason,
        buttonClass: 'link-btn',
        rowLimit: MAX_BRONZE_DOMAINS,
        entityName: 'domain',
        newRecord: {
            name: '',
            domainUrl: '',
            description: '',
            domainAction: fwVersionBronzeStore.hasReachedDomainLimitFor(ActionType.ALLOW) ? ActionType.BLOCK : ActionType.ALLOW
        },
        saveCb: (data: Domain) => fwVersionBronzeStore.addDomain(data),
        updateCb: (updatedRecord: Domain, originalRecord: Domain) =>
            fwVersionBronzeStore.updateDomain(updatedRecord, originalRecord),
        removeCb: (data: Domain) => fwVersionBronzeStore.removeDomain(data),
        dataChangesHandler: {},
        InfoMsg: PartialDisableMessage
    };
};